module.exports = __webpack_public_path__ + "static/img/nav17.58b0a12c.svg";